import { useTranslation } from "react-i18next";
import { cn } from "common-frontend-components";

interface CharacterCountProps {
    currentLength: number;
    maxLength: number;
    showCount?: boolean;
    warningThreshold?: number;
    className?: string;
}

export function CharacterCount({
    currentLength,
    maxLength,
    showCount = true,
    warningThreshold = 0.8,
    className = "",
}: CharacterCountProps) {
    const { t } = useTranslation();
    if (!showCount) return null;

    const remaining = maxLength - currentLength;
    const percentage = currentLength / maxLength;
    const isWarning = percentage >= warningThreshold;
    const isError = remaining < 0;

    const getColorClass = () => {
        if (isError) return "text-error";
        if (isWarning) return "text-warning";
        return "text-on-container/60";
    };

    return (
        <span className={cn("text-xs", getColorClass(), className)}>
            {t("common.charactersRemaining", { count: remaining })}
        </span>
    );
}
